module.exports = __webpack_public_path__ + "static/media/ishare.e482859b.png";